<template>
  <div class="float-action-button">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AgFloatButtonContainer',
}
</script>

<style lang="scss" scoped>
.float-action-button {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

.float-action-button * {
  margin: 8px;
}
</style>
